module.exports = __webpack_public_path__ + "img/REVOLUTION__1_-removebg-preview-p-500.ddd2b611.png";